var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 2.61133H35.4167V6.778H43.75V25.528H39.5833V10.9447H35.4167V15.1113H14.5833V10.9447H10.4167V44.278H25V48.4447H6.25V6.778H14.5833V2.61133ZM18.75 10.9447H31.25V6.778H18.75V10.9447ZM41.6667 29.6947V38.028H50V42.1947H41.6667V50.528H37.5V42.1947H29.1667V38.028H37.5V29.6947H41.6667Z",
    fill: "#34906E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskManager);
export default __webpack_public_path__ + "static/media/Task Manager.28966e7ff455e15fd852d575db3d59c3.svg";
export { ForwardRef as ReactComponent };